import { combineReducers } from 'redux';
import { nicTypesReducer } from './nic-types/slice';
import { operatingSystemsReducer } from './operating-systems/slice';

export const entitiesReducer = combineReducers({
  nicTypes: nicTypesReducer,
  operatingSystems: operatingSystemsReducer,
});
